export const JOYSPOT_QUIZ_URL = "https://www.tryinteract.com/share/quiz/699ad20365ce882cef3df208";
